import React from 'react';

import { useThumbsFeedback } from '../hooks/useThumbsFeedback';
import type { ThumbsFeedbackContainerProps } from '../types';

import { ThumbsFeedback } from './ThumbsFeedback';

/**
 * Container for the Thumbs Feedback widget.
 * Connects business logic (useThumbsFeedback hook) to the presentational component.
 */
export const ThumbsFeedbackContainer: React.FC<ThumbsFeedbackContainerProps> = props => {
  const state = useThumbsFeedback(props);
  return <ThumbsFeedback {...state} />;
};
